export default "__VITE_ASSET__BxBxjlDk__";